import coursePlanSimple from './coursePlanSimple';
import course from './course';
import result from './result';
import totalClass from './totalClass';
import detail from './detail';
import analysis from './analysis';
import classCollect from './classCollect';

export default {
    coursePlanSimple,
    course,
    result,
    totalClass,
    detail,
    analysis,
    classCollect
}
